// NZ Salary Database — role + region lookup
// Source: SEEK NZ (June 2026), Hays FY25/26
// confidence: "High" | "Medium" | "Low"
// v4 — 34 roles / 163 records
// Last updated: June 2026

const salaryDatabase = [
  // Barista
  { role: 'barista', region: 'auckland', minSalary: 55000, maxSalary: 60000, median: 57500, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'barista', region: 'wellington', minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'hourly', confidence: 'High' },
  { role: 'barista', region: 'hamilton', minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'hourly', confidence: 'High' },
  { role: 'barista', region: 'christchurch', minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'hourly', confidence: 'High' },
  { role: 'barista', region: 'queenstown', minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'hourly', confidence: 'High' },
  { role: 'barista', region: 'national', minSalary: 55000, maxSalary: 60000, median: 57500, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },

  // Retail Sales Assistant
  { role: 'retail sales assistant', region: 'auckland', minSalary: 50000, maxSalary: 60000, median: 55000, minHourly: 20.0, maxHourly: 30.0, medianHourly: 25.0, payType: 'both', confidence: 'High' },
  { role: 'retail sales assistant', region: 'wellington', minSalary: 55000, maxSalary: 60000, median: 57500, minHourly: 20.0, maxHourly: 30.0, medianHourly: 25.0, payType: 'both', confidence: 'High' },
  { role: 'retail sales assistant', region: 'hamilton', minSalary: 55000, maxSalary: 60000, median: 57500, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'retail sales assistant', region: 'christchurch', minSalary: 50000, maxSalary: 60000, median: 55000, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'retail sales assistant', region: 'queenstown', minSalary: 55000, maxSalary: 65000, median: 60000, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'retail sales assistant', region: 'national', minSalary: 50000, maxSalary: 65000, median: 57500, minHourly: 20.0, maxHourly: 30.0, medianHourly: 25.0, payType: 'both', confidence: 'High' },

  // Kitchen Hand
  { role: 'kitchen hand', region: 'auckland', minHourly: 20.0, maxHourly: 30.0, medianHourly: 25.0, payType: 'hourly', confidence: 'High' },
  { role: 'kitchen hand', region: 'wellington', minHourly: 20.0, maxHourly: 30.0, medianHourly: 25.0, payType: 'hourly', confidence: 'High' },
  { role: 'kitchen hand', region: 'hamilton', minHourly: 20.0, maxHourly: 30.0, medianHourly: 25.0, payType: 'hourly', confidence: 'High' },
  { role: 'kitchen hand', region: 'christchurch', minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'hourly', confidence: 'High' },
  { role: 'kitchen hand', region: 'queenstown', minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'hourly', confidence: 'High' },
  { role: 'kitchen hand', region: 'national', minHourly: 20.0, maxHourly: 30.0, medianHourly: 25.0, payType: 'hourly', confidence: 'High' },

  // Labourer
  { role: 'labourer', region: 'auckland', minSalary: 55000, maxSalary: 65000, median: 60000, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'labourer', region: 'wellington', minSalary: 55000, maxSalary: 65000, median: 60000, minHourly: 20.0, maxHourly: 30.0, medianHourly: 25.0, payType: 'both', confidence: 'High' },
  { role: 'labourer', region: 'hamilton', minSalary: 55000, maxSalary: 65000, median: 60000, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'labourer', region: 'christchurch', minSalary: 55000, maxSalary: 65000, median: 60000, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },
  { role: 'labourer', region: 'queenstown', minSalary: 55000, maxSalary: 65000, median: 60000, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },
  { role: 'labourer', region: 'national', minSalary: 55000, maxSalary: 65000, median: 60000, minHourly: 20.0, maxHourly: 35.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },

  // Café Manager
  { role: 'cafe manager', region: 'auckland', minSalary: 65000, maxSalary: 70000, median: 67500, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'cafe manager', region: 'wellington', minSalary: 65000, maxSalary: 75000, median: 70000, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },
  { role: 'cafe manager', region: 'hamilton', minSalary: 70000, maxSalary: 75000, median: 72500, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },
  { role: 'cafe manager', region: 'christchurch', minSalary: 70000, maxSalary: 80000, median: 75000, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'cafe manager', region: 'queenstown', minSalary: 70000, maxSalary: 75000, median: 72500, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'cafe manager', region: 'national', minSalary: 65000, maxSalary: 80000, median: 72500, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },

  // Chef
  { role: 'chef', region: 'auckland', minSalary: 80000, maxSalary: 90000, median: 85000, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },
  { role: 'chef', region: 'wellington', minSalary: 60000, maxSalary: 65000, median: 62500, minHourly: 30.0, maxHourly: 40.0, medianHourly: 35.0, payType: 'both', confidence: 'High' },
  { role: 'chef', region: 'hamilton', minSalary: 60000, maxSalary: 75000, median: 67500, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },
  { role: 'chef', region: 'christchurch', minSalary: 75000, maxSalary: 85000, median: 80000, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },
  { role: 'chef', region: 'queenstown', minSalary: 75000, maxSalary: 85000, median: 80000, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'chef', region: 'national', minSalary: 60000, maxSalary: 90000, median: 75000, minHourly: 25.0, maxHourly: 40.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },

  // Retail Store Manager
  { role: 'retail store manager', region: 'auckland', minSalary: 60000, maxSalary: 75000, median: 67500, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'retail store manager', region: 'wellington', minSalary: 60000, maxSalary: 80000, median: 70000, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },
  { role: 'retail store manager', region: 'hamilton', minSalary: 65000, maxSalary: 85000, median: 75000, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'retail store manager', region: 'christchurch', minSalary: 60000, maxSalary: 70000, median: 65000, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'retail store manager', region: 'queenstown', minSalary: 65000, maxSalary: 80000, median: 72500, minHourly: 30.0, maxHourly: 40.0, medianHourly: 35.0, payType: 'both', confidence: 'High' },
  { role: 'retail store manager', region: 'national', minSalary: 60000, maxSalary: 85000, median: 72500, minHourly: 25.0, maxHourly: 40.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },

  // Delivery Driver
  { role: 'delivery driver', region: 'auckland', minSalary: 55000, maxSalary: 65000, median: 60000, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },
  { role: 'delivery driver', region: 'wellington', minSalary: 60000, maxSalary: 65000, median: 62500, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'delivery driver', region: 'hamilton', minSalary: 55000, maxSalary: 65000, median: 60000, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'delivery driver', region: 'christchurch', minSalary: 60000, maxSalary: 65000, median: 62500, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },
  { role: 'delivery driver', region: 'queenstown', minSalary: 55000, maxSalary: 65000, median: 60000, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'delivery driver', region: 'national', minSalary: 55000, maxSalary: 65000, median: 60000, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },

  // Support Worker
  { role: 'support worker', region: 'auckland', minSalary: 55000, maxSalary: 60000, median: 57500, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },
  { role: 'support worker', region: 'wellington', minSalary: 55000, maxSalary: 75000, median: 65000, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'support worker', region: 'hamilton', minSalary: 55000, maxSalary: 65000, median: 60000, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'support worker', region: 'christchurch', minSalary: 55000, maxSalary: 65000, median: 60000, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'support worker', region: 'queenstown', minSalary: 60000, maxSalary: 70000, median: 65000, minHourly: 20.0, maxHourly: 30.0, medianHourly: 25.0, payType: 'both', confidence: 'High' },
  { role: 'support worker', region: 'national', minSalary: 55000, maxSalary: 75000, median: 65000, minHourly: 20.0, maxHourly: 35.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },

  // Production Worker
  { role: 'production worker', region: 'auckland', minSalary: 45000, maxSalary: 55000, median: 50000, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'production worker', region: 'wellington', minSalary: 45000, maxSalary: 55000, median: 50000, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'production worker', region: 'hamilton', minSalary: 45000, maxSalary: 55000, median: 50000, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'production worker', region: 'christchurch', minSalary: 45000, maxSalary: 55000, median: 50000, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'production worker', region: 'queenstown', minSalary: 45000, maxSalary: 55000, median: 50000, minHourly: 20.0, maxHourly: 30.0, medianHourly: 25.0, payType: 'both', confidence: 'High' },
  { role: 'production worker', region: 'national', minSalary: 45000, maxSalary: 55000, median: 50000, minHourly: 20.0, maxHourly: 30.0, medianHourly: 25.0, payType: 'both', confidence: 'High' },

  // Early Childhood Teacher
  { role: 'early childhood teacher', region: 'auckland', minSalary: 75000, maxSalary: 85000, median: 80000, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'early childhood teacher', region: 'wellington', minSalary: 75000, maxSalary: 85000, median: 80000, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'early childhood teacher', region: 'hamilton', minSalary: 65000, maxSalary: 80000, median: 72500, minHourly: 35.0, maxHourly: 40.0, medianHourly: 37.5, payType: 'both', confidence: 'High' },
  { role: 'early childhood teacher', region: 'christchurch', minSalary: 60000, maxSalary: 80000, median: 70000, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'early childhood teacher', region: 'queenstown', minSalary: 100000, maxSalary: 120000, median: 110000, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'early childhood teacher', region: 'national', minSalary: 60000, maxSalary: 120000, median: 90000, minHourly: 25.0, maxHourly: 40.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },

  // Production Supervisor
  { role: 'production supervisor', region: 'auckland', minSalary: 90000, maxSalary: 100000, median: 95000, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'production supervisor', region: 'wellington', minSalary: 115000, maxSalary: 135000, median: 125000, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'production supervisor', region: 'hamilton', minSalary: 85000, maxSalary: 95000, median: 90000, minHourly: 35.0, maxHourly: 40.0, medianHourly: 37.5, payType: 'both', confidence: 'High' },
  { role: 'production supervisor', region: 'christchurch', minSalary: 90000, maxSalary: 95000, median: 92500, minHourly: 30.0, maxHourly: 40.0, medianHourly: 35.0, payType: 'both', confidence: 'High' },
  { role: 'production supervisor', region: 'queenstown', minSalary: 85000, maxSalary: 90000, median: 87500, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'production supervisor', region: 'national', minSalary: 85000, maxSalary: 135000, median: 110000, minHourly: 30.0, maxHourly: 40.0, medianHourly: 35.0, payType: 'both', confidence: 'High' },

  // Landscaper
  { role: 'landscaper', region: 'auckland', minSalary: 60000, maxSalary: 70000, median: 65000, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'landscaper', region: 'wellington', minSalary: 55000, maxSalary: 75000, median: 65000, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },
  { role: 'landscaper', region: 'hamilton', minSalary: 55000, maxSalary: 75000, median: 65000, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },
  { role: 'landscaper', region: 'christchurch', minSalary: 55000, maxSalary: 75000, median: 65000, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'landscaper', region: 'queenstown', minSalary: 55000, maxSalary: 75000, median: 65000, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'landscaper', region: 'national', minSalary: 55000, maxSalary: 75000, median: 65000, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },

  // Carpenter
  { role: 'carpenter', region: 'auckland', minSalary: 70000, maxSalary: 85000, median: 77500, minHourly: 35.0, maxHourly: 40.0, medianHourly: 37.5, payType: 'both', confidence: 'High' },
  { role: 'carpenter', region: 'wellington', minSalary: 75000, maxSalary: 95000, median: 85000, minHourly: 35.0, maxHourly: 40.0, medianHourly: 37.5, payType: 'both', confidence: 'High' },
  { role: 'carpenter', region: 'hamilton', minSalary: 75000, maxSalary: 95000, median: 85000, minHourly: 30.0, maxHourly: 40.0, medianHourly: 35.0, payType: 'both', confidence: 'High' },
  { role: 'carpenter', region: 'christchurch', minSalary: 75000, maxSalary: 90000, median: 82500, minHourly: 35.0, maxHourly: 40.0, medianHourly: 37.5, payType: 'both', confidence: 'High' },
  { role: 'carpenter', region: 'queenstown', minSalary: 80000, maxSalary: 85000, median: 82500, minHourly: 35.0, maxHourly: 40.0, medianHourly: 37.5, payType: 'both', confidence: 'High' },
  { role: 'carpenter', region: 'national', minSalary: 70000, maxSalary: 95000, median: 82500, minHourly: 30.0, maxHourly: 40.0, medianHourly: 35.0, payType: 'both', confidence: 'High' },

  // Builder
  { role: 'builder', region: 'auckland', minSalary: 80000, maxSalary: 90000, median: 85000, minHourly: 35.0, maxHourly: 45.0, medianHourly: 40.0, payType: 'both', confidence: 'High' },
  { role: 'builder', region: 'wellington', minSalary: 80000, maxSalary: 90000, median: 85000, minHourly: 30.0, maxHourly: 40.0, medianHourly: 35.0, payType: 'both', confidence: 'High' },
  { role: 'builder', region: 'hamilton', minSalary: 80000, maxSalary: 90000, median: 85000, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'builder', region: 'christchurch', minSalary: 80000, maxSalary: 90000, median: 85000, minHourly: 30.0, maxHourly: 40.0, medianHourly: 35.0, payType: 'both', confidence: 'High' },
  { role: 'builder', region: 'queenstown', minSalary: 80000, maxSalary: 90000, median: 85000, minHourly: 35.0, maxHourly: 45.0, medianHourly: 40.0, payType: 'both', confidence: 'High' },
  { role: 'builder', region: 'national', minSalary: 80000, maxSalary: 90000, median: 85000, minHourly: 30.0, maxHourly: 45.0, medianHourly: 37.5, payType: 'both', confidence: 'High' },

  // Electrician
  { role: 'electrician', region: 'auckland', minSalary: 90000, maxSalary: 95000, median: 92500, minHourly: 40.0, maxHourly: 50.0, medianHourly: 45.0, payType: 'both', confidence: 'High' },
  { role: 'electrician', region: 'wellington', minSalary: 75000, maxSalary: 95000, median: 85000, minHourly: 35.0, maxHourly: 45.0, medianHourly: 40.0, payType: 'both', confidence: 'High' },
  { role: 'electrician', region: 'hamilton', minSalary: 90000, maxSalary: 95000, median: 92500, minHourly: 40.0, maxHourly: 45.0, medianHourly: 42.5, payType: 'both', confidence: 'High' },
  { role: 'electrician', region: 'christchurch', minSalary: 80000, maxSalary: 85000, median: 82500, minHourly: 40.0, maxHourly: 45.0, medianHourly: 42.5, payType: 'both', confidence: 'High' },
  { role: 'electrician', region: 'queenstown', minSalary: 70000, maxSalary: 90000, median: 80000, minHourly: 35.0, maxHourly: 45.0, medianHourly: 40.0, payType: 'both', confidence: 'High' },
  { role: 'electrician', region: 'national', minSalary: 70000, maxSalary: 95000, median: 82500, minHourly: 35.0, maxHourly: 50.0, medianHourly: 42.5, payType: 'both', confidence: 'High' },

  // Plumber
  { role: 'plumber', region: 'auckland', minSalary: 75000, maxSalary: 95000, median: 85000, minHourly: 40.0, maxHourly: 50.0, medianHourly: 45.0, payType: 'both', confidence: 'High' },
  { role: 'plumber', region: 'wellington', minSalary: 75000, maxSalary: 85000, median: 80000, minHourly: 35.0, maxHourly: 45.0, medianHourly: 40.0, payType: 'both', confidence: 'High' },
  { role: 'plumber', region: 'hamilton', minSalary: 80000, maxSalary: 85000, median: 82500, minHourly: 35.0, maxHourly: 45.0, medianHourly: 40.0, payType: 'both', confidence: 'High' },
  { role: 'plumber', region: 'christchurch', minSalary: 80000, maxSalary: 85000, median: 82500, minHourly: 30.0, maxHourly: 40.0, medianHourly: 35.0, payType: 'both', confidence: 'High' },
  { role: 'plumber', region: 'queenstown', minSalary: 75000, maxSalary: 85000, median: 80000, minHourly: 35.0, maxHourly: 45.0, medianHourly: 40.0, payType: 'both', confidence: 'High' },
  { role: 'plumber', region: 'national', minSalary: 75000, maxSalary: 95000, median: 85000, minHourly: 30.0, maxHourly: 50.0, medianHourly: 40.0, payType: 'both', confidence: 'High' },

  // Duty Manager
  { role: 'duty manager', region: 'auckland', minSalary: 65000, maxSalary: 75000, median: 70000, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },
  { role: 'duty manager', region: 'wellington', minSalary: 60000, maxSalary: 70000, median: 65000, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },
  { role: 'duty manager', region: 'hamilton', minSalary: 60000, maxSalary: 70000, median: 65000, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },
  { role: 'duty manager', region: 'christchurch', minSalary: 60000, maxSalary: 65000, median: 62500, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'duty manager', region: 'queenstown', minSalary: 70000, maxSalary: 75000, median: 72500, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },
  { role: 'duty manager', region: 'national', minSalary: 60000, maxSalary: 75000, median: 67500, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },

  // Hospitality Manager
  { role: 'hospitality manager', region: 'auckland', minSalary: 75000, maxSalary: 85000, median: 80000, payType: 'salary', confidence: 'High' },
  { role: 'hospitality manager', region: 'wellington', minSalary: 80000, maxSalary: 95000, median: 87500, payType: 'salary', confidence: 'High' },
  { role: 'hospitality manager', region: 'hamilton', minSalary: 115000, maxSalary: 120000, median: 117500, payType: 'salary', confidence: 'High' },
  { role: 'hospitality manager', region: 'christchurch', minSalary: 90000, maxSalary: 105000, median: 97500, payType: 'salary', confidence: 'High' },
  { role: 'hospitality manager', region: 'queenstown', minSalary: 80000, maxSalary: 95000, median: 87500, payType: 'salary', confidence: 'High' },
  { role: 'hospitality manager', region: 'national', minSalary: 75000, maxSalary: 120000, median: 97500, payType: 'salary', confidence: 'High' },

  // Hairdresser
  { role: 'hairdresser', region: 'auckland', minSalary: 65000, maxSalary: 70000, median: 67500, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'hairdresser', region: 'wellington', minSalary: 70000, maxSalary: 75000, median: 72500, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'hairdresser', region: 'hamilton', minSalary: 65000, maxSalary: 70000, median: 67500, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'hairdresser', region: 'christchurch', minSalary: 65000, maxSalary: 70000, median: 67500, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'hairdresser', region: 'queenstown', minSalary: 65000, maxSalary: 70000, median: 67500, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'hairdresser', region: 'national', minSalary: 65000, maxSalary: 75000, median: 70000, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },

  // Forklift Driver
  { role: 'forklift driver', region: 'auckland', minSalary: 60000, maxSalary: 70000, median: 65000, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'forklift driver', region: 'wellington', minSalary: 60000, maxSalary: 70000, median: 65000, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },
  { role: 'forklift driver', region: 'hamilton', minSalary: 65000, maxSalary: 70000, median: 67500, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'forklift driver', region: 'christchurch', minSalary: 60000, maxSalary: 70000, median: 65000, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'forklift driver', region: 'queenstown', minSalary: 60000, maxSalary: 70000, median: 65000, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },
  { role: 'forklift driver', region: 'national', minSalary: 60000, maxSalary: 70000, median: 65000, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },

  // Cleaner
  { role: 'cleaner', region: 'auckland', minSalary: 50000, maxSalary: 55000, median: 52500, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },
  { role: 'cleaner', region: 'wellington', minSalary: 60000, maxSalary: 65000, median: 62500, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'cleaner', region: 'hamilton', minSalary: 60000, maxSalary: 65000, median: 62500, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'cleaner', region: 'christchurch', minSalary: 60000, maxSalary: 65000, median: 62500, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'cleaner', region: 'queenstown', minSalary: 60000, maxSalary: 65000, median: 62500, minHourly: 25.0, maxHourly: 30.0, medianHourly: 27.5, payType: 'both', confidence: 'High' },
  { role: 'cleaner', region: 'national', minSalary: 50000, maxSalary: 65000, median: 57500, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },

  // Painter
  { role: 'painter', region: 'auckland', minSalary: 80000, maxSalary: 85000, median: 82500, minHourly: 30.0, maxHourly: 40.0, medianHourly: 35.0, payType: 'both', confidence: 'High' },
  { role: 'painter', region: 'wellington', minSalary: 80000, maxSalary: 85000, median: 82500, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },
  { role: 'painter', region: 'hamilton', minSalary: 80000, maxSalary: 85000, median: 82500, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'painter', region: 'christchurch', minSalary: 80000, maxSalary: 85000, median: 82500, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'painter', region: 'queenstown', minSalary: 80000, maxSalary: 85000, median: 82500, minHourly: 30.0, maxHourly: 35.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },
  { role: 'painter', region: 'national', minSalary: 80000, maxSalary: 85000, median: 82500, minHourly: 25.0, maxHourly: 40.0, medianHourly: 32.5, payType: 'both', confidence: 'High' },

  // Administration Assistant (Hays FY25/26)
  { role: 'administration assistant', region: 'auckland', minSalary: 60000, maxSalary: 68000, median: 62000, minHourly: 28.85, maxHourly: 32.69, medianHourly: 29.81, payType: 'both', confidence: 'High' },
  { role: 'administration assistant', region: 'wellington', minSalary: 58000, maxSalary: 65000, median: 62000, minHourly: 27.88, maxHourly: 31.25, medianHourly: 29.81, payType: 'both', confidence: 'High' },
  { role: 'administration assistant', region: 'christchurch', minSalary: 56000, maxSalary: 65000, median: 65000, minHourly: 26.92, maxHourly: 31.25, medianHourly: 31.25, payType: 'both', confidence: 'High' },

  // Office Manager (Hays FY25/26)
  { role: 'office manager', region: 'auckland', minSalary: 70000, maxSalary: 80000, median: 75000, minHourly: 33.65, maxHourly: 38.46, medianHourly: 36.06, payType: 'both', confidence: 'High' },
  { role: 'office manager', region: 'wellington', minSalary: 70000, maxSalary: 90000, median: 80000, minHourly: 33.65, maxHourly: 43.27, medianHourly: 38.46, payType: 'both', confidence: 'High' },
  { role: 'office manager', region: 'christchurch', minSalary: 65000, maxSalary: 82000, median: 70000, minHourly: 31.25, maxHourly: 39.42, medianHourly: 33.65, payType: 'both', confidence: 'High' },

  // Receptionist (Hays FY25/26)
  { role: 'receptionist', region: 'auckland', minSalary: 60000, maxSalary: 65000, median: 62000, minHourly: 28.85, maxHourly: 31.25, medianHourly: 29.81, payType: 'both', confidence: 'High' },
  { role: 'receptionist', region: 'wellington', minSalary: 51000, maxSalary: 58000, median: 55000, minHourly: 24.52, maxHourly: 27.88, medianHourly: 26.44, payType: 'both', confidence: 'High' },
  { role: 'receptionist', region: 'christchurch', minSalary: 56000, maxSalary: 60000, median: 58000, minHourly: 26.92, maxHourly: 28.85, medianHourly: 27.88, payType: 'both', confidence: 'High' },

  // Medical Receptionist (Hays FY25/26)
  { role: 'medical receptionist', region: 'auckland', minSalary: 61000, maxSalary: 75000, median: 67000, minHourly: 29.33, maxHourly: 36.06, medianHourly: 32.21, payType: 'both', confidence: 'High' },
  { role: 'medical receptionist', region: 'wellington', minSalary: 60000, maxSalary: 70000, median: 65000, minHourly: 28.85, maxHourly: 33.65, medianHourly: 31.25, payType: 'both', confidence: 'High' },
  { role: 'medical receptionist', region: 'christchurch', minSalary: 62000, maxSalary: 72000, median: 67000, minHourly: 29.81, maxHourly: 34.62, medianHourly: 32.21, payType: 'both', confidence: 'High' },

  // Personal Assistant (Hays FY25/26)
  { role: 'personal assistant', region: 'auckland', minSalary: 75000, maxSalary: 90000, median: 85000, minHourly: 36.06, maxHourly: 43.27, medianHourly: 40.87, payType: 'both', confidence: 'High' },
  { role: 'personal assistant', region: 'wellington', minSalary: 57000, maxSalary: 64000, median: 60000, minHourly: 27.4, maxHourly: 30.77, medianHourly: 28.85, payType: 'both', confidence: 'High' },
  { role: 'personal assistant', region: 'christchurch', minSalary: 65000, maxSalary: 75000, median: 70000, minHourly: 31.25, maxHourly: 36.06, medianHourly: 33.65, payType: 'both', confidence: 'High' },

  // Customer Service Representative (Hays FY25/26)
  { role: 'customer service representative', region: 'auckland', minSalary: 55000, maxSalary: 65000, median: 60000, minHourly: 26.44, maxHourly: 31.25, medianHourly: 28.85, payType: 'both', confidence: 'High' },
  { role: 'customer service representative', region: 'wellington', minSalary: 54000, maxSalary: 62000, median: 57000, minHourly: 25.96, maxHourly: 29.81, medianHourly: 27.4, payType: 'both', confidence: 'High' },
  { role: 'customer service representative', region: 'christchurch', minSalary: 50000, maxSalary: 55000, median: 52000, minHourly: 24.04, maxHourly: 26.44, medianHourly: 25.0, payType: 'both', confidence: 'High' },

  // Sales Representative (Hays FY25/26)
  { role: 'sales representative', region: 'auckland', minSalary: 70000, maxSalary: 90000, median: 80000, minHourly: 33.65, maxHourly: 43.27, medianHourly: 38.46, payType: 'both', confidence: 'High' },
  { role: 'sales representative', region: 'wellington', minSalary: 65000, maxSalary: 85000, median: 70000, minHourly: 31.25, maxHourly: 40.87, medianHourly: 33.65, payType: 'both', confidence: 'High' },
  { role: 'sales representative', region: 'christchurch', minSalary: 60000, maxSalary: 75000, median: 65000, minHourly: 28.85, maxHourly: 36.06, medianHourly: 31.25, payType: 'both', confidence: 'High' },

  // Warehouse Storeperson (Hays FY25/26 — national only)
  { role: 'warehouse storeperson', region: 'national', minSalary: 50000, maxSalary: 60000, median: 55000, minHourly: 24.04, maxHourly: 28.85, medianHourly: 26.44, payType: 'both', confidence: 'Medium' },

  // Warehouse Coordinator (Hays FY25/26 — national only)
  { role: 'warehouse coordinator', region: 'national', minSalary: 60000, maxSalary: 75000, median: 65000, minHourly: 28.85, maxHourly: 36.06, medianHourly: 31.25, payType: 'both', confidence: 'Medium' },

  // Warehouse Supervisor (Hays FY25/26 — national only)
  { role: 'warehouse supervisor', region: 'national', minSalary: 70000, maxSalary: 90000, median: 80000, minHourly: 33.65, maxHourly: 43.27, medianHourly: 38.46, payType: 'both', confidence: 'Medium' },

  // Waiter / Food and Beverage Attendant (SEEK NZ — national only)
  { role: 'waiter food and beverage attendant', region: 'national', minSalary: 60000, maxSalary: 65000, median: 63000, minHourly: 25.0, maxHourly: 35.0, medianHourly: 30.0, payType: 'both', confidence: 'High' },
];

const regionAliases = {
  'auckland': 'auckland',
  'akl': 'auckland',
  'auckland cbd': 'auckland',
  'north shore': 'auckland',
  'manukau': 'auckland',
  'east auckland': 'auckland',
  'west auckland': 'auckland',
  'south auckland': 'auckland',
  'wellington': 'wellington',
  'wgtn': 'wellington',
  'lower hutt': 'wellington',
  'upper hutt': 'wellington',
  'porirua': 'wellington',
  'christchurch': 'christchurch',
  'chch': 'christchurch',
  'canterbury': 'christchurch',
  'hamilton': 'hamilton',
  'waikato': 'hamilton',
  'tauranga': 'tauranga',
  'bay of plenty': 'tauranga',
  'dunedin': 'dunedin',
  'otago': 'dunedin',
  'palmerston north': 'palmerston north',
  'napier': 'napier',
  'hastings': 'napier',
  'hawkes bay': 'napier',
  "hawke's bay": 'napier',
  'nelson': 'nelson',
  'rotorua': 'rotorua',
  'new plymouth': 'new plymouth',
  'taranaki': 'new plymouth',
  'whangarei': 'whangarei',
  'invercargill': 'invercargill',
  'southland': 'invercargill',
  'queenstown': 'queenstown',
  'otago / queenstown': 'queenstown',
  'wanaka': 'queenstown',
  'queenstown lakes': 'queenstown',
};

// ── Role alias map ────────────────────────────────────────────────────────────
// Maps typed role strings and tokens to canonical DB role keys.
const roleAliasMap = {
  // Hospitality
  'coffee maker': 'barista', 'cafe staff': 'barista',
  'cafe worker': 'barista', 'coffee': 'barista', 'espresso': 'barista',
  'cafe manager': 'cafe manager', 'café manager': 'cafe manager',
  'coffee shop manager': 'cafe manager', 'cafe supervisor': 'cafe manager',
  'cook': 'chef', 'head chef': 'chef', 'sous chef': 'chef',
  'chef de partie': 'chef', 'pastry chef': 'chef',
  'kitchenhand': 'kitchen hand', 'kitchen staff': 'kitchen hand',
  'kitchen worker': 'kitchen hand', 'kitchen assistant': 'kitchen hand',
  'kitchen offsider': 'kitchen hand',
  'waiter': 'waiter food and beverage attendant',
  'waitress': 'waiter food and beverage attendant',
  'food and beverage attendant': 'waiter food and beverage attendant',
  'foh': 'waiter food and beverage attendant',
  'front of house': 'waiter food and beverage attendant',
  'floor staff': 'waiter food and beverage attendant',
  'wait staff': 'waiter food and beverage attendant',
  'server': 'waiter food and beverage attendant',
  'food and beverage': 'waiter food and beverage attendant',
  'hospitality duty manager': 'duty manager',
  'bar manager': 'duty manager', 'floor manager': 'duty manager',
  'restaurant manager': 'hospitality manager',
  'venue manager': 'hospitality manager',
  'food and beverage manager': 'hospitality manager',
  // Retail
  'retail assistant': 'retail sales assistant',
  'sales assistant': 'retail sales assistant',
  'shop assistant': 'retail sales assistant',
  'retail staff': 'retail sales assistant',
  'retail worker': 'retail sales assistant',
  'store manager': 'retail store manager',
  'shop manager': 'retail store manager',
  'retail manager': 'retail store manager',
  // Construction & Trades
  'laborer': 'labourer', 'construction hand': 'labourer',
  'trade assistant': 'labourer', 'general hand': 'labourer',
  'yard hand': 'labourer', 'civil labourer': 'labourer',
  'builders labourer': 'labourer', 'builders assistant': 'labourer',
  'construction worker': 'labourer',
  'joiner': 'carpenter', 'carpenter joiner': 'carpenter',
  'finishing carpenter': 'carpenter', 'formwork carpenter': 'carpenter',
  'construction manager': 'builder', 'building contractor': 'builder',
  'site foreman': 'builder', 'head builder': 'builder',
  'builder carpenter': 'builder',
  'electrical worker': 'electrician', 'sparky': 'electrician',
  'licensed electrician': 'electrician',
  'plumbing': 'plumber', 'gasfitter': 'plumber',
  'plumber gasfitter': 'plumber', 'registered plumber': 'plumber',
  'painter decorator': 'painter', 'house painter': 'painter',
  'commercial painter': 'painter', 'decorator': 'painter',
  // Transport & Logistics
  'courier': 'delivery driver', 'courier driver': 'delivery driver',
  'truck driver': 'delivery driver', 'van driver': 'delivery driver',
  'freight driver': 'delivery driver',
  'forklift operator': 'forklift driver', 'forklift': 'forklift driver',
  'counterbalance operator': 'forklift driver',
  'reach truck operator': 'forklift driver',
  'storeperson': 'warehouse storeperson',
  'warehouse staff': 'warehouse storeperson',
  'warehouse worker': 'warehouse storeperson',
  'picker packer': 'warehouse storeperson',
  'warehouse assistant': 'warehouse storeperson',
  'inventory controller': 'warehouse coordinator',
  'stock controller': 'warehouse coordinator',
  'warehouse admin': 'warehouse coordinator',
  'warehouse team leader': 'warehouse supervisor',
  'warehouse manager': 'warehouse supervisor',
  // Healthcare & Social
  'care worker': 'support worker',
  'disability support worker': 'support worker',
  'community support worker': 'support worker',
  'home care worker': 'support worker',
  'carer': 'support worker', 'support staff': 'support worker',
  // Manufacturing
  'process worker': 'production worker',
  'factory worker': 'production worker',
  'factory hand': 'production worker', 'line worker': 'production worker',
  'production operator': 'production worker',
  'machine operator': 'production worker',
  'assembly worker': 'production worker',
  'line supervisor': 'production supervisor',
  'shift supervisor': 'production supervisor',
  'manufacturing supervisor': 'production supervisor',
  'factory supervisor': 'production supervisor',
  // Education
  'ece teacher': 'early childhood teacher',
  'early childhood educator': 'early childhood teacher',
  'kindergarten teacher': 'early childhood teacher',
  'preschool teacher': 'early childhood teacher',
  'childcare teacher': 'early childhood teacher',
  'educator': 'early childhood teacher',
  // Office Support
  'admin assistant': 'administration assistant',
  'office administrator': 'administration assistant',
  'admin': 'administration assistant',
  'office support': 'administration assistant',
  'administrator': 'administration assistant',
  'business manager': 'office manager',
  'practice manager': 'office manager',
  'front desk': 'receptionist',
  'office receptionist': 'receptionist',
  'medical secretary': 'medical receptionist',
  'practice administrator': 'medical receptionist',
  'clinic receptionist': 'medical receptionist',
  'dental receptionist': 'medical receptionist',
  'pa': 'personal assistant',
  'executive assistant': 'personal assistant',
  'ea': 'personal assistant', 'executive pa': 'personal assistant',
  // Customer Service & Sales
  'customer service rep': 'customer service representative',
  'customer service officer': 'customer service representative',
  'csr': 'customer service representative',
  'contact centre': 'customer service representative',
  'customer service': 'customer service representative',
  'call centre': 'customer service representative',
  'sales rep': 'sales representative',
  'sales consultant': 'sales representative',
  'territory manager': 'sales representative',
  'account manager': 'sales representative',
  'bdm': 'sales representative',
  // Other
  'groundskeeper': 'landscaper', 'grounds maintenance': 'landscaper',
  'lawn care': 'landscaper', 'gardener': 'landscaper',
  'horticulturalist': 'landscaper',
  'cleaning staff': 'cleaner', 'housekeeper': 'cleaner',
  'commercial cleaner': 'cleaner', 'office cleaner': 'cleaner',
  'janitor': 'cleaner',
  'hair stylist': 'hairdresser', 'barber': 'hairdresser',
  'beautician': 'hairdresser', 'stylist': 'hairdresser',
  'salon': 'hairdresser',
};

// ── Region proximity map ──────────────────────────────────────────────────────
// Where regionAliases has no matching DB record, fall back to nearest proxy.
const regionProximityMap = {
  'tauranga': 'hamilton', 'bay of plenty': 'hamilton',
  'rotorua': 'hamilton', 'whangarei': 'hamilton',
  'new plymouth': 'hamilton', 'taranaki': 'hamilton',
  'gisborne': 'hamilton', 'hawkes bay': 'hamilton',
  "hawke's bay": 'hamilton', 'napier': 'hamilton',
  'hastings': 'hamilton',
  'palmerston north': 'wellington',
  'nelson': 'christchurch', 'marlborough': 'christchurch',
  'blenheim': 'christchurch',
  'invercargill': 'christchurch', 'southland': 'christchurch',
  'timaru': 'christchurch', 'ashburton': 'christchurch',
  'greymouth': 'christchurch', 'gore': 'christchurch',
  'dunedin': 'queenstown', 'otago': 'queenstown',
  'wanaka': 'queenstown',
};

// ── Stop words stripped before token matching ─────────────────────────────────
const ROLE_STOP_WORDS = new Set([
  'and', 'or', 'the', 'a', 'an', 'of', 'in', 'at', 'for', 'to', 'with',
  'senior', 'junior', 'associate', 'graduate', 'lead', 'experienced',
  'qualified', 'certified', 'licensed',
]);

function normaliseRole(roleStr) {
  if (!roleStr) return '';
  return roleStr.trim().toLowerCase()
    .replace(/[/\\&+,()[\]{}'"]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function tokeniseRole(normRole) {
  return normRole.split(/[\s-]+/)
    .filter(t => t.length > 1 && !ROLE_STOP_WORDS.has(t));
}

function resolveRoleKey(normRole) {
  // 1. Direct alias lookup (full string)
  if (roleAliasMap[normRole]) return roleAliasMap[normRole];
  // 2. Already a DB key
  if (salaryDatabase.some(e => e.role === normRole)) return normRole;
  // 3. Token-based alias lookup
  const tokens = tokeniseRole(normRole);
  for (const token of tokens) {
    if (roleAliasMap[token]) return roleAliasMap[token];
  }
  // 4. Token overlap with DB role keys
  const tokenSet = new Set(tokens);
  const dbRoles = [...new Set(salaryDatabase.map(e => e.role))];
  let bestRole = null, bestOverlap = 0;
  for (const dbRole of dbRoles) {
    const overlap = tokeniseRole(dbRole).filter(t => tokenSet.has(t)).length;
    if (overlap > bestOverlap) { bestOverlap = overlap; bestRole = dbRole; }
  }
  if (bestOverlap >= 2) return bestRole;
  return null;
}

function normaliseRegion(locationStr) {
  if (!locationStr) return null;
  const lower = locationStr.trim().toLowerCase()
    .replace(/[()[\]]/g, '').replace(/\s+/g, ' ').trim();
  return regionAliases[lower] || regionProximityMap[lower] || lower;
}

function formatCurrency(amount) {
  return '$' + Math.round(amount).toLocaleString('en-NZ');
}

/**
 * Look up salary data for a role + region combination.
 * Returns { found, payType, range, median, confidence, source, note? }
 * or { found: false } when no match exists.
 */
export function lookupSalary(role, location) {
  const resolvedRole = resolveRoleKey(normaliseRole(role));
  const normRegion = normaliseRegion(location);
  const SOURCE = 'RoleReady NZ Pay Ranges · June 2026 review';

  if (!resolvedRole) return { found: false };

  function buildResult(match, note) {
    const r = {
      found: true,
      payType: match.payType,
      confidence: match.confidence,
      source: SOURCE,
    };
    if (match.payType === 'hourly' || match.payType === 'both') {
      r.range = `${formatCurrency(match.minHourly)}/hr – ${formatCurrency(match.maxHourly)}/hr`;
      r.median = `${formatCurrency(match.medianHourly)}/hr`;
    }
    if (match.payType === 'salary') {
      r.range = `${formatCurrency(match.minSalary)} – ${formatCurrency(match.maxSalary)} per year`;
      r.median = formatCurrency(match.median);
    }
    if (match.payType === 'both') {
      r.salaryRange = `${formatCurrency(match.minSalary)} – ${formatCurrency(match.maxSalary)} per year`;
      r.salaryMedian = formatCurrency(match.median);
    }
    if (note) r.note = note;
    return r;
  }

  // 1. Exact region match
  let match = salaryDatabase.find(
    e => e.role === resolvedRole && e.region === normRegion
  );
  if (match) return buildResult(match);

  // 2. Proximity fallback
  const proxy = regionProximityMap[normRegion];
  if (proxy) {
    match = salaryDatabase.find(
      e => e.role === resolvedRole && e.region === proxy
    );
    if (match) return buildResult(match,
      `Showing ${proxy.charAt(0).toUpperCase() + proxy.slice(1)} data — regional figures for your location not yet available.`
    );
  }

  // 3. National fallback
  match = salaryDatabase.find(
    e => e.role === resolvedRole && e.region === 'national'
  );
  if (match) return buildResult(match,
    'Regional data not yet available — showing national estimate.'
  );

  // 4. Any region (last resort, low confidence)
  match = salaryDatabase.find(e => e.role === resolvedRole);
  if (match) {
    const result = buildResult(match,
      'Regional data not yet available — showing national estimate.'
    );
    result.confidence = 'Low';
    return result;
  }

  return { found: false };
}
